<template>
  <div class="follow-list">
    <!-- 客户跟进记录（企业微信手机端） -->
    <mobile-list-header>
      <!-- 第一行：搜索框占满整行，左输入框 + 右搜索按钮 -->
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchInfo.searchKey" placeholder="跟进内容" @keyup.enter="resetSearch"/>
          <yq-icon v-if="searchInfo.searchKey" class="icon clear" name="element-ui_close" @click="clearKey"/>
        </div>
        <div class="search-btn" @click="resetSearch">搜索</div>
      </div>
      <!-- 第二行：查询条件，无背景色，点开选择框选值或清除 -->
      <div class="filter-row">
        <mobile-search-select v-model="searchInfo.partnerId" :query="queryCustomerPage" size="small"
                              label-column="merchantRemarkName" code-column="id"
                              placeholder="客户" search-placeholder="客户名称/手机号"
                              @change="resetSearch">
          <!-- 客户名称下方补一行联系电话：同名客户最容易记混，电话能区分 -->
          <template #item="{item}">
            <div class="mss-item">
              <div class="mss-item-main">{{ item.merchantRemarkName }}</div>
              <div class="mss-item-sub">{{ item.merchantRemarkPhone || "无联系电话" }}</div>
            </div>
          </template>
        </mobile-search-select>
        <mobile-search-select v-model="searchInfo.followEmployeeId" :query="queryEmployeePage" size="small"
                              label-column="employeeName" code-column="id"
                              placeholder="跟进人" search-placeholder="职员名称/手机号"
                              @change="resetSearch">
          <!-- 职员按「头像 + 名称 / 手机号」两行显示（预览模板 B） -->
          <template #item="{item}">
            <div class="mss-item mss-item-avatar-row">
              <div class="mss-item-avatar">
        <img v-if="item.iconUrl" :src="$getImageUrl(item.iconUrl)" alt=""/>
        <yq-icon v-else name="element-ui_user"/>
              </div>
              <div class="mss-item-info">
        <div class="mss-item-main">{{ item.employeeName }}</div>
        <div class="mss-item-sub">{{ item.employeePhone || "无联系电话" }}</div>
              </div>
            </div>
          </template>
        </mobile-search-select>
      </div>
    </mobile-list-header>
    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList" :refresh="resetSearch" ref="mobileList">
      <list-card class="follow-item" v-for="item in dataList" :key="item.id" :label="item.partnerTitle">
        <template #desc>{{ formatDate(item.followTime) }}</template>
        <div class="follow-content">{{ item.followContent }}</div>
        <data-column label="跟进人">{{ item.followEmployeeName || "-" }}</data-column>
        <data-column label="下次跟进">{{ item.nextFollowDate || "-" }}</data-column>
      </list-card>
    </mobile-list>
    <!-- 悬浮「新增跟进」按钮：右下角，可拖动 -->
    <mobile-float-button label="新增跟进" icon="element-ui_plus" @click="toCreate"/>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import MobileSearchSelect from "@/components/qywx/data/MobileSearchSelect.vue";
import MobileFloatButton from "@/components/qywx/button/MobileFloatButton.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import customerFollowApi from "@/api/normal/common/customerFollowApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import commonApi from "@/api/commonApi";
import {PARTNER_TYPE} from "@/views/h5/crm/crmDictionary";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "CFL",
  components: {
    YqIcon, DataColumn, ListCard, MobileFloatButton, MobileSearchSelect, MobileListHeader, MobileList
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        searchKey: "",
        partnerId: "",
        followEmployeeId: "",
        pageNumber: 0,
        pageSize: 20,
        hasMore: true, // 初始为 true，列表挂载后由无限滚动自动触发首次查询
      },
      dataList: [],
    };
  },
  methods: {
    queryList() {
      this.loading = true;
      this.searchInfo.pageNumber++;
      customerFollowApi.queryList(this.searchInfo).then(res => {
        this.dataList = this.dataList.concat(res.records || []);
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
        this.$refs.mobileList.hideRefreshTitle();
      }).catch(() => {
        this.loading = false;
      })
    },
    // 重置查询条件，从第一页开始查
    resetSearch() {
      this.searchInfo.pageNumber = 0;
      this.dataList = [];
      this.searchInfo.hasMore = true;
      this.queryList();
    },
    clearKey() {
      this.searchInfo.searchKey = "";
      this.resetSearch();
    },
    // 跟进时间只取到日，卡片标题行放不下完整时间
    formatDate(value) {
      return value ? String(value).slice(0, 10) : "";
    },
    // 客户选择框的数据源：走通用往来单位接口（带数据权限），需要显式传 partnerType
    queryCustomerPage(params) {
      return commonDataApi.queryPartnerList({...params, partnerType: PARTNER_TYPE.CUSTOMER});
    },
    // 跟进人选择框的数据源
    queryEmployeePage(params) {
      return commonApi.queryEmployeeListByPage(params);
    },
    toCreate() {
      this.router.push("/qywx/partner/customer-follow/detail");
    }
  }
};
</script>

<style lang="scss" scoped>
.follow-list{
  height: 100%;
  display: flex;
  flex-direction: column;
  // 悬浮按钮的定位祖先
  position: relative;
}
// 第一行：搜索框占满整行，左输入框 + 右搜索按钮
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
// 第二行：查询条件，无背景色，超过一屏横向滑动
.filter-row{
  display: flex;
  gap: 18px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  > *{
    flex: none;
  }
}
.follow-item{
  // 跟进内容是多行文本（textarea 录入）：整段展示、保留换行，不做截断
  // （跟进详情页已去掉，列表是唯一能读到完整内容的地方）
  .follow-content{
    margin-top: 10px;
    padding: 10px;
    border-radius: 4px;
    background: var(--yq-background-color);
    font-size: var(--yq-font-size-mini-mobile);
    color: var(--yq-font-color-tips);
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: anywhere;
  }
}
</style>
